/**
 * Created by andrey on 15.12.2020.
 */

const Map2dEditorView = EditorViewBase.extend({
    ctor: function (editor) {
        this._super(editor);

        const styles = cleverapps.styles.Map2dEditorView;

        const map = this.map = new EditorMap2dView({
            width: this.width,
            height: this.height
        });
        this.addChild(map);

        if (Editor.currentEditor.map.reference.isAvailable()) {
            const referenceControls = new EditorMap2dReferenceControls(Editor.currentEditor.map.reference);
            this.addChild(referenceControls);
        }

        if (editor.map.getBackgroundBundle()) {
            const backgroundControls = new EditorMap2dBackgroundControls(editor);
            this.addChild(backgroundControls);
        }

        const layersSwitcherView = new LayersSwitcherView(editor.layers);
        layersSwitcherView.setAlignment(styles.layers);
        this.addChild(layersSwitcherView);

        layersSwitcherView.onLayerSwitched = (layerId) => editor.setLayer(layerId);
        layersSwitcherView.onLayerVisibilityChanged = (layerId, visible) => editor.setLayerVisible(layerId, visible);

        editor.on("changeLayer", (layer) => layersSwitcherView.setLayer(layer), layersSwitcherView);
        editor.on("changeLayerVisibility", (layer, visible) => layersSwitcherView.setLayerVisible(layer, visible), layersSwitcherView);

        if (editor.editorClient) {
            const editorClientLayout = new cleverapps.Layout([
                new EditorClientStatus(editor.editorClient),
                new EditorCommandLogView(editor.editorClient.commandLog)], {
                margin: styles.editorClientLayout.margin,
                direction: cleverapps.UI.VERTICAL
            });

            this.addChild(editorClientLayout);
            editorClientLayout.setAlignment(styles.editorClientLayout);
        }

        if (editor.editorPointers) {
            this.pointerViews = {};
            editor.editorPointers.on("addPointer", this.addPointerView.bind(this), this);
            editor.editorPointers.on("removePointer", this.removePointerView.bind(this), this);
        }

        this.addToggles();
        if (cleverapps.meta.getSelectedLocation().locationConfig.locationType === "homefix") {
            this.addWallsToggle();
        }
        this.addPasteBinContent();

        this.onResize();
    },

    addPointerView: function (pointer) {
        const mapView = Map2d.currentMap.getMapView();
        const view = new EditorPointerView(pointer);
        mapView.addChild(view);
        this.pointerViews[pointer.userId] = view;
    },

    removePointerView: function (pointer) {
        const view = this.pointerViews[pointer.userId];
        if (view) {
            view.removeFromParent();
            delete this.pointerViews[pointer.userId];
        }
    },

    addToggles: function () {
        const styles = cleverapps.styles.Map2dEditorView.toggles;

        const toggles = [new cleverapps.UI.CheckBox({
            label: {
                text: "fogs",
                font: cleverapps.styles.FONTS.EDITOR_BLUE_TEXT
            },
            onChange: function (state) {
                Editor.currentEditor.map.fogs.toggleAlwaysVisible(state);
            }
        }), new cleverapps.UI.CheckBox({
            label: {
                text: "bounds",
                font: cleverapps.styles.FONTS.EDITOR_BLUE_TEXT
            },
            onChange: function (state) {
                Editor.currentEditor.setBoundsMode(state);
            }
        })];

        const layout = new cleverapps.Layout(toggles, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        this.addChild(layout);
        layout.setAlignment(styles);
    },

    addWallsToggle: function () {
        const wallToggle = new cleverapps.UI.CheckBox({
            label: {
                text: "wall toggle",
                font: cleverapps.styles.FONTS.EDITOR_BLUE_TEXT
            },
            onChange: function (state) {
                Map2dFences.toggleAlwaysShort(state);
            }
        });

        this.addChild(wallToggle);
        wallToggle.setAlignment(cleverapps.styles.Map2dEditorView.wallToggle);
    },

    addPasteBinContent: function () {
        const pastebinIcon = new cc.Sprite(bundles.admin.frames.pastebin);
        const styles = cleverapps.styles.Map2dEditorView.pastebin;

        this.addChild(pastebinIcon);
        pastebinIcon.setAlignment(styles);

        const count = cleverapps.clipboardService.getCountOfCopiedItems();
        const text = new cleverapps.UI.ImageFont(count, cleverapps.styles.FONTS.EDITOR_HINT);

        text.setDimensions(styles.text.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        pastebinIcon.addChild(text);
        pastebinIcon.counterText = text;
        text.setAlignment(styles.text);
        pastebinIcon.setVisible(count > 0);

        cleverapps.clipboardService.on("changed", this.updatePasteBinContent.bind(this, pastebinIcon), this);
    },

    updatePasteBinContent: function (pastebinIcon) {
        const count = cleverapps.clipboardService.getCountOfCopiedItems();
        if (count > 0) {
            pastebinIcon.counterText.setString(count);
            pastebinIcon.setVisible(true);
        } else {
            pastebinIcon.setVisible(false);
        }
    },

    onResize: function () {
        this._super();

        if (this.map) {
            const bgSize = cleverapps.resolution.getBgSize();
            const safePadding = cleverapps.resolution.getSafePadding();
            this.map.setContentSize(bgSize.width, bgSize.height);
            this.map.setAlignment(bgSize.width / 2 - safePadding.left, bgSize.height / 2 - safePadding.bottom);

            this.map.zoomHandler.setZoom(this.map.zoom, true);
            this.map.updateVisibility();
        }
    }
});

cleverapps.styles.Map2dEditorView = {
    editorClientLayout: {
        margin: 10,
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -225 }
    },

    layers: {
        x: { align: "left", dx: 60 },
        y: { align: "top", dy: -120 }
    },
    toggles: {
        margin: 40,
        x: { align: "left", dx: 65 },
        y: { align: "top", dy: -20 }
    },
    
    wallToggle: {
        x: { align: "left", dx: 65 },
        y: { align: "top", dy: -140 }
    },

    pastebin: {
        x: { align: "right", dx: -50 },
        y: { align: "top", dy: -220 },

        text: {
            width: 45,
            x: { align: "center", dx: -4 },
            y: { align: "center", dy: 4 }
        }
    }
};

if (typeof EditorView === "undefined") {
    EditorView = Map2dEditorView;
}